import { closest } from "@/javascript/components/tools/closest"
import smallTalk from "@/javascript/components/smalltalk"

document.addEventListener('click', (e) => {
  const elem = closest(e.target, '[data-clipboard]')
  if(!elem) {
    return
  }

  const value = elem.dataset.clipboard
  navigator.clipboard.writeText(value).then(() => {
    smallTalk(elem, 'Copied to clipboard')
  })
})

